(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('med-report-line', {
            parent: 'entity',
            url: '/med-report-line?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReportLine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report-line/med-report-lines.html',
                    controller: 'MedReportLineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReportLine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('med-report-line-detail', {
            parent: 'entity',
            url: '/med-report-line/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.medReportLine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/med-report-line/med-report-line-detail.html',
                    controller: 'MedReportLineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medReportLine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MedReportLine', function($stateParams, MedReportLine) {
                    return MedReportLine.get({id : $stateParams.id});
                }]
            }
        })
        .state('med-report-line.new', {
            parent: 'med-report-line',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report-line/med-report-line-dialog.html',
                    controller: 'MedReportLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                aQuantity: null,
                                bQuantity: null,
                                sum: null,
                                marketSharePercentage: null,
                                numberOfChanges: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('med-report-line', null, { reload: true });
                }, function() {
                    $state.go('med-report-line');
                });
            }]
        })
        .state('med-report-line.edit', {
            parent: 'med-report-line',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report-line/med-report-line-dialog.html',
                    controller: 'MedReportLineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MedReportLine', function(MedReportLine) {
                            return MedReportLine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report-line', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('med-report-line.delete', {
            parent: 'med-report-line',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/med-report-line/med-report-line-delete-dialog.html',
                    controller: 'MedReportLineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MedReportLine', function(MedReportLine) {
                            return MedReportLine.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('med-report-line', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
